import React, { useContext } from 'react'
import { Row, Col } from 'react-bootstrap'

import AgentInstaller from "./AgentInstaller";

const EnrollDevice = () => {
  return (
    <div>
      <Row className='mb-4'>
        <Col>
          <p>Here you can enrol your device and allow Calligo to collect needed compliance data about your device.</p>
          <p>
            If you have already installed the agent, please allow 10-20 minutes for your device to appear in our system.
            If after this time period, your device still does not appear, please create a ticket either
            through <a href='https://cloudhelp.viaje.cloud'>CloudHelp</a> or our <a href='https://www.calligo.io/customer-support/'>website</a> whichever you have access to.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <AgentInstaller />
        </Col>
      </Row>
    </div>
  )
}

export default EnrollDevice
